import { categories, trustBadges } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20gradient%20waves%20in%20warm%20peach%20coral%20and%20sage%20green%20tones%20on%20cream%20background%2C%20contemporary%20artistic%20backdrop%2C%20smooth%20flowing%20organic%20shapes%2C%20modern%20minimal%20aesthetic%2C%20serene%20elegant%20atmosphere%2C%20no%20objects%20no%20text%20just%20pure%20abstract%20art&width=1800&height=1200&seq=hero-main-v2&orientation=landscape"
          alt="Basetao Spreadsheet fashion product flat lay background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20 pb-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
          The #1 Basetao Spreadsheet
          <br />
          <span className="text-primary-200">Resource Hub</span>
        </h1>

        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Find the best Basetao products, updated spreadsheets, QC guides, shipping information and expert reviews — all in one beautifully organized place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-bag-3-line"></i>
            </span>
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-rocket-line"></i>
            </span>
            Buy It Now
          </a>
        </div>

        <div className="hidden md:block relative w-full max-w-xs mx-auto mb-10">
          <div className="group relative">
            <span className="flex items-center justify-between w-full px-5 py-3 rounded-xl bg-white/95 backdrop-blur-sm border border-white/40 text-foreground-800 text-sm font-medium cursor-pointer">
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-search-line text-primary-500"></i>
                </span>
                Browse by Category
              </span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-s-line text-foreground-400"></i>
              </span>
            </span>
            <div className="absolute left-0 right-0 top-full mt-1 bg-white rounded-xl border border-background-200 py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 max-h-64 overflow-y-auto z-20">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors"
                >
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm text-primary-500`}></i>
                  </span>
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6">
          {trustBadges.map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-white/70 text-sm">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-primary-200 text-sm`}></i>
              </span>
              <span>{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}